module.exports = __webpack_public_path__ + "static/media/u21a-c_07_v2.c7651a4a.mp3";